import { Button, Result } from 'antd';
import { Outlet } from 'react-router';
import { endImpersonation, getImpersonatedRental, getStoredUser } from '@/services/auth';
import { isAdmin } from '@/types/models';

/**
 * Wraps a platform screen route. An Admin impersonating a Rental works as its Manager,
 * so the screen waits for Global view. Not `canAccessResource`: other users reach the
 * page, which shows its own refusal.
 */
export const PlatformRouteGuard = ({ screenName }: { screenName: string }): React.JSX.Element => {
  const impersonatedRental = isAdmin(getStoredUser()) ? getImpersonatedRental() : null;

  if (!impersonatedRental) return <Outlet />;

  return (
    <Result
      status="info"
      title={`${screenName} are not available here`}
      subTitle="This is a platform screen. Exit the impersonation to open it."
      extra={
        <Button
          type="primary"
          onClick={() => {
            void endImpersonation(impersonatedRental.id);
          }}
        >
          Exit Impersonation
        </Button>
      }
    />
  );
};
